import { useNavigate, useLocation } from 'react-router-dom'
import React from 'react'
import FullScreenCallout from '../../Common/fullScreenCallout/FullScreenCallout'
import { fullScreenCalloutAccessModeVariants } from './_utils'
import { FullScreenCalloutAccessModeProps } from './_props'
import FullScreenCalloutAccessModeExpandedContent from './FullScreenCalloutAccessModeExpandedContent'

const FullScreenCalloutAccessMode: React.FC<FullScreenCalloutAccessModeProps> = ({ mode }) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    if (!mode) return null

    const fullScreenContent = fullScreenCalloutAccessModeVariants[mode]

    return (
        <FullScreenCallout
            title={fullScreenContent.title}
            text={fullScreenContent.text}
            buttonName={fullScreenContent?.buttonName}
            action={mode === 'conforme' || pathname === '/me' ? undefined : () => navigate('/me')}
            expandedContent={mode === 'flexible' && <FullScreenCalloutAccessModeExpandedContent />}
        />
    )
}
export default FullScreenCalloutAccessMode
